import React, { Component } from 'react'
import { connect } from 'react-redux'
import { History } from 'history'

import { selectUser } from '../../../reducers'
import { deleteAddress, fetchUser } from '../userActions'
import { UserBanner } from '../userBanner'
import { UserAddressDetails } from './userAddressDetails'
import { User } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  user: User
  deleteAddress: Callback
  fetchUser: Callback
  history: History
  match: Match<ParamsID>
}

export class UserAddresses extends Component<Props> {
  static displayName = 'UserAddresses'

  state = { selectedAddress: '' }

  componentWillMount() {
    this.fetchUserData()
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props
    if (match.params.id !== prevProps.match.params.id) {
      this.fetchUserData()
    }
  }

  fetchUserData = () => {
    const { fetchUser, match } = this.props
    fetchUser(match.params.id)
  }

  selectAddressCard = (id) => {
    const { selectedAddress } = this.state
    if (!selectedAddress || selectedAddress !== id) {
      this.setState(() => ({ selectedAddress: id }))
    } else {
      this.setState(() => ({ selectedAddress: '' }))
    }
  }

  deleteUserAddress = () => {
    const { deleteAddress } = this.props
    const result = window.confirm(
      'Are you sure you want to delete this address?'
    )
    if (result) {
      deleteAddress(this.state.selectedAddress)
    }
    this.setState(() => ({ selectedAddress: '' }))
  }

  done = () => {
    this.props.history.goBack()
  }

  render() {
    const { user } = this.props
    if (!user.id) return null

    return (
      <div className="user-address">
        <div className="user-address__user-banner">
          <UserBanner
            address={user.currentAddress}
            context="User"
            user={user}
          />
        </div>
        <UserAddressDetails
          done={this.done}
          deleteUserAddress={this.deleteUserAddress}
          selectAddressCard={this.selectAddressCard}
          selectedAddress={this.state.selectedAddress}
          user={user}
        />
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    user: selectUser(state.users, match.params.id),
  }
}

export default connect(mapStateToProps, { fetchUser, deleteAddress })(
  UserAddresses
)
